import { ROUTES_URL } from 'src/constants/routes';
import useSessionStore from 'src/stores/session';
import useUserStore from 'src/stores/user';

export default function useOnboardingLogoTarget() {
    const { isAuthorized, hasSessionSnapshot } = useSessionStore(({ isAuthorized, hasSessionSnapshot }) => ({
        isAuthorized,
        hasSessionSnapshot,
    }));
    const isOnboardingCompleted = useUserStore(({ isOnboardingCompleted }) => isOnboardingCompleted);

    if (!isAuthorized || !hasSessionSnapshot || isOnboardingCompleted) {
        return '/';
    }

    return ROUTES_URL.BEGIN_WORK;
}
